import React from 'react'

const CTA = () => {
  return (
    <div className = 'cta'>
        <a href = 'https://nurturingmachines.files.wordpress.com/2024/01/manan_kharwar_engphys_may2024.pdf' target ="_blank" rel='noreferrer' download className='btn'>Download CV</a>
        <a href = '#contact' className='btn btn-primary'>Let's Talk</a>
    </div>

  )
}

export default CTA